var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 129.844,
    height: 36.627,
    viewBox: "0 0 129.844 36.627",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_453",
    "data-name": "Groupe 453",
    transform: "translate(-310.078 -50)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_430",
    "data-name": "Groupe 430",
    transform: "translate(148.078 -6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_519",
    "data-name": "Trac\\xE9 519",
    d: "M320.278,21.821a10.811,10.811,0,0,0,5.746,6.353c4.368,1.961,8.538,1.175,12.533-1.162a3.2,3.2,0,0,1,4.084.26,3.531,3.531,0,0,1-.373,5.8,16.478,16.478,0,0,1-7.426,3.14c-4.306.621-8.515.348-12.421-1.735a17.748,17.748,0,0,1-9.883-14.724,18.077,18.077,0,0,1,16-19.62c8.794-1.023,17.649,4.158,19.839,13.335a22.631,22.631,0,0,1,.533,4.472c.081,2.418-1.435,3.881-3.871,3.883q-11.835.009-23.67,0h-1.089m20.82-7.287c-.888-4.156-5.46-7.332-10.426-7.311-4.643.02-9.512,3.474-10.262,7.311Z",
    transform: "translate(-93.713 56.499)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_520",
    "data-name": "Trac\\xE9 520",
    d: "M543.412,36.863A18.3,18.3,0,0,1,540.463.525a18.623,18.623,0,0,1,18.448,8.248,3.854,3.854,0,0,1-.856,5.5,3.872,3.872,0,0,1-5.345-1.588,10.848,10.848,0,0,0-10.767-5.059,11.158,11.158,0,0,0-9.312,8.5,11.058,11.058,0,0,0,6.4,12.49,10.862,10.862,0,0,0,13.344-3.739c.983-1.409,2.181-2.267,3.942-1.977a3.521,3.521,0,0,1,2.451,5.466,17.6,17.6,0,0,1-11.5,7.987c-1.26.275-2.565.347-3.849.512",
    transform: "translate(-267.834 56.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_521",
    "data-name": "Trac\\xE9 521",
    d: "M128.029,36.97a18.294,18.294,0,0,1-18.112-19.425A18.246,18.246,0,0,1,143.651,9.09a3.664,3.664,0,0,1-.982,5.31,3.747,3.747,0,0,1-5.21-1.5,11.046,11.046,0,0,0-20.427,6.51,11.223,11.223,0,0,0,8.024,9.817A10.9,10.9,0,0,0,137.1,24.887a3.747,3.747,0,0,1,3.629-1.921,3.541,3.541,0,0,1,2.621,5.61,17.608,17.608,0,0,1-11.467,7.89c-1.261.27-2.565.342-3.849.5",
    transform: "translate(72.072 56.155)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_522",
    "data-name": "Trac\\xE9 522",
    d: "M63.655,46.014a3.565,3.565,0,0,1-2.975-1.691,27.669,27.669,0,0,1-2.512-30.816,3.547,3.547,0,0,1,6.669,1.923,5.046,5.046,0,0,1-.559,1.695c-4.061,8.143-3.344,15.822,2.214,23.037A3.441,3.441,0,0,1,67,44.045a3.361,3.361,0,0,1-3.348,1.969",
    transform: "translate(117.303 46.988)",
    fill: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_523",
    "data-name": "Trac\\xE9 523",
    d: "M.039,81.188c0-.452-.008-.9,0-1.357a3.359,3.359,0,0,1,3.438-3.424,3.408,3.408,0,0,1,3.429,3.461A29.083,29.083,0,0,0,9.461,91.95c.318.714.694,1.4,1.033,2.106a3.447,3.447,0,0,1-6.079,3.253A34.48,34.48,0,0,1,.256,84.16C.147,83.173.084,82.181,0,81.192l.039,0",
    transform: "translate(162 -6.031)",
    fill: "#4188f2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9dbe62634949131ced73ee21e01292ed.svg";
export { ForwardRef as ReactComponent };